import { lazy, Suspense } from "react";
import "./main.css";
import "./responsive.css";
import HeroSection from "./Hero";
import Secoundsection from "./Counter";
import Thirddsection from "./Services";
import Article from "./Article";
const Slider = lazy(() => import("./SliderHome"));


function Main() {
  return (
    <div className="main-container">
      <section className="HeroSection">
        <HeroSection />
      </section>
      <section>
        <Secoundsection />
      </section>
      <section>
        <Thirddsection />
      </section>
      
      <section>
        <Article />
      </section>
      <section>
        <Suspense fallback={<div style={{ minHeight: 120 }} />}>
          <Slider />
        </Suspense>
      </section>
     
    </div>
  );
}

export default Main;
